import { NavType } from '../enum/chatEnum'

export interface NavigationItem {
  label: string
  value: string
  type: NavType
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

/** Normalizes all HTTP/history/live navigation entries for the requested language, preserving order. */
export function getNavigationFormat(payload: unknown, language: string): NavigationItem[] {
  if (!Array.isArray(payload)) return []

  const items: NavigationItem[] = []
  for (const entry of payload) {
    if (!isRecord(entry) || !Array.isArray(entry.btnContent)) continue
    const type = entry.actionType
    if (type !== NavType.TRANSFER_AGENT && type !== NavType.QUESTION && type !== NavType.LINK)
      continue

    for (const button of entry.btnContent) {
      if (!isRecord(button) || button.value !== language || typeof button.name !== 'string')
        continue
      items.push({
        label: button.name,
        value: typeof button.url === 'string' ? button.url : '',
        type,
      })
    }
  }
  return items
}
